import t from '@instructure/quiz-i18n/es/format-message';
export var boundaries = function boundaries(val, options) {
  var enableKey = options.enableKey || 'enabled';
  var minKey = options.minKey || 'min';
  var maxKey = options.maxKey || 'max';
  var valMinKey = val[minKey];
  var valMaxKey = val[maxKey];
  if (enableKey !== null && !val[enableKey]) {
    return;
  }
  if (valMinKey === void 0 && valMaxKey === void 0 || valMinKey === null && valMaxKey === null) {
    var defaultMessage = t('must define a value');
    var message = options.presenceMessage || defaultMessage;
    return message;
  }
  if (valMinKey !== void 0 && valMinKey !== null) {
    var minAsNumber = parseFloat(valMinKey);
    var _defaultMessage = t('must be a number');
    var _message = options.numberMessage || _defaultMessage;
    if (!Number.isFinite(minAsNumber) || !Number.isInteger(minAsNumber)) {
      return _message;
    }
  }
  if (valMaxKey !== void 0 && valMaxKey !== null) {
    var maxAsNumber = parseFloat(valMaxKey);
    var _defaultMessage2 = t('must be a number');
    var _message2 = options.numberMessage || _defaultMessage2;
    if (!Number.isFinite(maxAsNumber) || !Number.isInteger(maxAsNumber)) {
      return _message2;
    }
  }
  if (valMinKey !== void 0 && valMaxKey !== void 0 || valMinKey !== null && valMaxKey !== null) {
    var _minAsNumber = parseFloat(valMinKey);
    var _maxAsNumber = parseFloat(valMaxKey);
    var _defaultMessage3 = t('min must be less than max');
    var _message3 = options.rangeMessage || _defaultMessage3;
    if (_minAsNumber >= _maxAsNumber) {
      return _message3;
    }
  }
};
export default boundaries;